var render = function render(){var _vm=this,_c=_vm._self._c;return _c('simple-modal',_vm._g(_vm._b({attrs:{"min-width":_vm.minWidth}},'simple-modal',_vm.$attrs,false),_vm.$listeners),[_c('md-card',{staticClass:"card-modal"},[_c('md-card-header',[_vm._t("header")],2),_vm._v(" "),_c('md-card-content',[_vm._t("body"),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),_c('md-card-actions',[_vm._t("footer")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/Modal.vue